module.exports = __webpack_public_path__ + "static/media/elevatehack.7dc65d8c.png";